import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Container,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AuthLogo from '../../components/common/AuthLogo';
import hosannaTextLogo from '../../assets/hosanna_text_logo.png';

function Signup({ phoneNumber, onSignup, loading }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Name is required');
      return;
    }

    try {
      await onSignup(phoneNumber, name);
    } catch (err) {
      setError(err.message || 'Failed to create account');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          pt: 4,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 400 }}>
          <Box
            component="img"
            src={hosannaTextLogo}
            alt="Hosanna"
            sx={{
              maxWidth: { xs: '200px', sm: '250px' },
              width: '100%',
              height: 'auto',
              mb: 3,
            }}
          />
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ p: 4 }}>
            <AuthLogo maxWidth={150} maxHeight={150} />
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ color: 'primary.main' }}>
              Create Account
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
              Complete your profile for {phoneNumber}
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                margin="normal"
                required
                disabled={loading}
                autoFocus
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{ mt: 3, py: 1.5 }}
                disabled={loading || !name.trim()}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {loading ? 'Creating Account...' : 'Create Account'}
              </Button>
            </Box>
          </CardContent>
        </Card>
        </Box>
      </Box>
    </Container>
  );
}

export default Signup;

